import { number, object, string } from 'yup'

export const lorSchema = searchID => {
	return object({
		...!searchID && { officePickupID: number().required('Offices is required') },
		currency: string().required('Currency is required'),
		dates: string().required( 'Must provide at least 1 date'),
	})
}
